<script >
import $t from '../common/i18n';
import useStockQuote from '../composables/useStockQuote';
import useUserWch from '../composables/useUserWch';
import useUpDownType from '../composables/useUpDownType';
import { getSchemeLink } from '../common/scheme';
const __sfc_main = {};
__sfc_main.props = {
  stockId: Number,
  upDownType: Number,
  increaseType: String,
  schemeType: String
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    loaded,
    stockQuote
  } = useStockQuote(props);
  const {
    selectedStatus,
    setSelectStatus
  } = useUserWch(props.stockId);
  const {
    upDownTypeCls
  } = useUpDownType(props);

  // 点击跳转
  const {
    useBehaviour
  } = require('@fegobull/webapi').use;
  const {
    runBehaviour
  } = useBehaviour();
  const onClick = $event => {
    if (!props.schemeType) return;
    const link = getSchemeLink(props.stockId, props.schemeType);
    runBehaviour(null, {
      type: 'jump',
      value: link
    }, $event);
  };
  return {
    $t,
    loaded,
    stockQuote,
    selectedStatus,
    setSelectStatus,
    upDownTypeCls,
    onClick
  };
};
export default __sfc_main;
</script>
<template>
    <div class="quotes-card-v2" :class="{ loading: !loaded }" @click="onClick">
        <div class="header-block">
            <div class="stock-info">
                <p class="stock-info__symbol over-text">{{ stockQuote.symbol }}</p>
                <p class="stock-info__name over-text">{{ stockQuote.name }}</p>
            </div>
            <img
                v-if="selectedStatus"
                class="wch-icon"
                src="../images/added-wch.png"
                @click.stop="setSelectStatus($event, false)"
                alt="added"
            />
            <img
                v-else
                class="wch-icon"
                src="../images/add-wch.png"
                @click.stop="setSelectStatus($event, true)"
                alt="add"
            />
        </div>
        <div class="stock-quote">
            <div>
                <p
                    :class="[
                        'stock-quote__increase-rate',
                        upDownTypeCls,
                        {
                            up: stockQuote.rate > 0,
                            down: stockQuote.rate < 0
                        }
                    ]"
                >
                    {{ stockQuote.rateStr }}
                </p>
                <p class="stock-quote__increase-type">{{ $t(increaseType) }}</p>
            </div>
            <div>
                <p class="stock-quote__row" v-if="stockQuote.aum">
                    {{ $t('aum') }}
                    <span class="stock-quote__value">{{ stockQuote.aum }}</span>
                </p>
                <p class="stock-quote__row" v-if="stockQuote.dividendYield">
                    {{ $t('divYield') }}
                    <span class="stock-quote__value">{{ stockQuote.dividendYield }}</span>
                </p>
            </div>
        </div>
    </div>
</template>
<style lang="less" scoped>
@import './index.less';
</style>
